import { render } from "./AccountBlockedCard.vue?vue&type=template&id=ca9209ac&scoped=true"
import script from "./AccountBlockedCard.vue?vue&type=script&lang=js"
export * from "./AccountBlockedCard.vue?vue&type=script&lang=js"

import "./AccountBlockedCard.vue?vue&type=style&index=0&id=ca9209ac&lang=scss&scoped=true"

import exportComponent from "D:\\Epaylater Projects\\microapp-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca9209ac"]])

export default __exports__